var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("certs-table", {
        attrs: { rows: _vm.rows },
        on: { "request-certificados": _vm.fetchCertificados },
      }),
      _vm._v(" "),
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": false },
      }),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          staticClass: "mt-4",
          attrs: { open: _vm.expanded },
          on: {
            "update:open": function ($event) {
              _vm.expanded = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function () {
                return [
                  _vm.activeEstadoLabel
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "box is-clickable is-flex is-justify-content-space-between is-align-items-center",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "has-text-weight-semibold" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.activeOrgName) +
                                  " — " +
                                  _vm._s(_vm.activeEstadoLabel) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.expanded
                                ? "chevron-down"
                                : "chevron-left",
                              size: "is-small",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box" },
            [
              _vm.certificados.length
                ? _c("certs-panel", {
                    attrs: { certificados: _vm.certificados },
                  })
                : _c("div", { staticClass: "has-text-grey" }, [
                    _vm._v(
                      "\n        No hay certificados para mostrar\n      "
                    ),
                  ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }